import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '../../form/button/button.module';
import { ListToolbarComponent } from './list-toolbar.component';
import { TextfieldComponent } from '../../form/textfield/textfield.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, ButtonModule, TextfieldComponent, ListToolbarComponent],
  exports: [ListToolbarComponent],
})
export class ListToolbarModule {}
